import * as actions from "../../services/referAFriend/action";
import update from "immutability-helper";

let initialState = {
  campaign: {
    fetching: false,
    fetched: false,
    data: [],
    error: null,
  },
  referred: {
    fetching: false,
    fetched: false,
    data: [],
    error: null,
  },
};

const referAFriend = (state = initialState, action) => {
  switch (action.type) {
    case actions.ADD_CAMPAIGN_REQUEST:
      return update(state, {
        campaign: {
          fetching: { $set: true },
          error: { $set: null },
        },
      });

    case actions.ADD_CAMPAIGN_ERROR:
      return update(state, {
        campaign: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.ADD_CAMPAIGN_SUCCESS:
      return update(state, {
        campaign: {
          fetching: { $set: false },
          fetched: { $set: true },
        },
      });

    case actions.GET_CAMPAIGNS_REQUEST:
      return update(state, {
        campaign: {
          fetching: { $set: true },
        },
      });

    case actions.GET_CAMPAIGNS_SUCCESS:
      return update(state, {
        campaign: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });

    case actions.GET_CAMPAIGNS_ERROR:
      return update(state, {
        campaign: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.GET_REFERRED_REQUEST:
      return update(state, {
        referred: {
          fetching: { $set: true },
        },
      });

    case actions.GET_REFERRED_SUCCESS:
      return update(state, {
        referred: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });

    case actions.GET_REFERRED_ERROR:
      return update(state, {
        referred: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.DELETE_CAMPAIGN_REQUEST:
      return update(state, {
        campaign: {
          fetching: { $set: true },
        },
      });

    case actions.DELETE_CAMPAIGN_ERROR:
      return update(state, {
        campaign: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.UPDATE_START_DATE_REQUEST:
      return update(state, {
        campaign: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });

    case actions.UPDATE_END_DATE_REQUEST:
      return update(state, {
        campaign: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });

    default:
      return state;
  }
};

export default referAFriend;
